module.exports = __webpack_public_path__ + "img/shangwuxuan.da713cd0.jpg";